import React from "react";
import { FaCheckCircle, FaTools, FaHome, FaHandshake } from "react-icons/fa";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About Us</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Your trusted local appliance service partner
          </p>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="md:flex">
                {/* Founder Image */}
                <div className="md:w-1/3 bg-gradient-to-br from-blue-600 to-blue-700 p-12 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-36 h-36 bg-white rounded-full mx-auto mb-4 overflow-hidden shadow-lg">
                      <img
                        src="/Sachin_half.png"
                        alt="Sachin Paswan - Founder & Service Technician"
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <h3 className="text-2xl font-bold text-white">
                      Sachin Paswan
                    </h3>
                    <p className="text-blue-100 mt-2">
                      Founder & Service Technician
                    </p>
                  </div>
                </div>

                {/* Founder Info */}
                <div className="md:w-2/3 p-8 md:p-12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">
                    Meet Our Founder
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p className="leading-relaxed">
                      <strong className="text-blue-700">
                        A.P. Cool Service
                      </strong>{" "}
                      is founded and operated by <strong>Sachin Paswan</strong>,
                      a dedicated appliance service professional committed to
                      providing quality door-to-door repair services.
                    </p>
                    <p className="leading-relaxed">
                      We believe in honest service, fair pricing, and building
                      long-term relationships with our customers. Every service
                      call is handled with the same care and attention we would
                      give to our own home.
                    </p>
                    <p className="leading-relaxed">
                      Our mission is simple: provide reliable, affordable
                      appliance repair services right at your doorstep, so you
                      don't have to worry about transporting heavy equipment or
                      dealing with complicated processes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            What We Stand For
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <FaHome className="text-blue-600 text-3xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Door-to-Door Service
              </h3>
              <p className="text-gray-700">
                We come to you. No need to move your appliances.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <FaCheckCircle className="text-blue-600 text-3xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Local & Reliable
              </h3>
              <p className="text-gray-700">
                We're part of your community, serving local families.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <FaHandshake className="text-blue-600 text-3xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Customer-First
              </h3>
              <p className="text-gray-700">
                Your satisfaction is our priority. Always.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <FaTools className="text-blue-600 text-3xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Quality Work
              </h3>
              <p className="text-gray-700">
                Professional service with lasting results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Experience the Difference
          </h2>
          <p className="text-lg mb-8 text-blue-100 max-w-2xl mx-auto">
            Call Sachin Paswan today for reliable appliance service
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:8655557727"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              📞 +91 8655557727
            </a>
            <a
              href="tel:7054773277"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              📞 +91 7054773277
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
